<template>
  <div>
    <AdvancedForm
      v-if="studentList.length === 0"
      :on-search="handleAdvancedSearch"
      :impediment-list="impedimentList"
      :current-search="currentSearch"
      :records-not-found="recordsNotFound"
    />
    <div v-else-if="!selectedStudent">
      <Filters v-if="false" />
      <ResultList
        v-if="canShowList"
        :student-list="studentList"
        :pagination="paginationInfo"
        @select-student="selectStudent"
        @pagination-go-page="goToPage"
      />

      <div
        class="filtered-result-foot prevent-close-dialog"
        @click="goToAdvancedForm()"
      >
        <i class="fas fa-angle-double-left prevent-close-dialog" />
        <span class="prevent-close-dialog">Criterios de búsqueda</span>
      </div>
    </div>
  </div>
</template>

<script>
import AdvancedForm from './AdvancedForm';
import ResultList from './ResultList';
import Filters from './Filters';
import store from '@/store/index';
import loading from '@/mixin/loading.mixin';
import alert from '@/mixin/alert.mixin';
import moment from 'moment';

import studentService from '@/services/student';
import resourcesService from '@/services/resources.js';
import { trackingNavMenu as _trackingNavMenu } from "@/modules/user/api";
import { getCurrentAcademicYear } from "@/services/api/tapRequest.api.js";
export default {
  name: 'StudentSearchAdvanced',
  components: {
    AdvancedForm,
    ResultList,
    Filters,
  },
  mixins: [loading],
  props: ['showAdvancedSearch'],
  data() {
    return {
      currentSearch: {},
      studentList: [],
      impedimentList: [],
      paginationInfo: {},
      selectedStudent: null,
      recordsNotFound: false,
      resources: [],
      academicYearId: null,
    };
  },
  computed: {
    canShowList() {
      return this.studentList.length > 0 && !this.selectedStudent;
    },
    viewCard() {
      return store.state.navigateToViewCard;
    },
  },
  created() {
    this.loadResources();
  },
  methods: {
    async handleAdvancedSearch(searchInput) {
      this.currentSearch = searchInput;
      const input = { ...searchInput, ...this.paginationInfo };
      input.birthDate = moment(input.birthDate).format('DD/MMM/YYYY');
      this.setLoading(true);

      try {
        const { data: response } = await studentService.getAdvancedSearch(
          input
        );
        this.studentList = response.data;
        this.recordsNotFound = this.studentList.length === 0;

        const paginationInfo = { ...response };
        delete paginationInfo.data;
        this.paginationInfo = paginationInfo;
      } finally {
        this.setLoading(false);
      }
    },
    async getCurrentAcademicYear() {
      let { data } = await  getCurrentAcademicYear()
      return data.id;
    },
    goToAdvancedForm() {
      this.studentList = [];
    },

    async selectStudent(student) {
      if (student) {
        let canAccess = student.canAccess;

        if (canAccess) {
          this.academicYearId = await this.getCurrentAcademicYear();
          this.selectedStudent = student;
          this.clean();
          let webServiceSearchOnly =
            store.getters.WebServiceStudentSearchEnabled;
          const payload = {
            navMenuId: isNaN(this.viewCard) ? 0 : Number(this.viewCard),
            academicYearId: this.academicYearId,
            studentSieId: isNaN(student.studentId) ? null : Number(student.studentId),
          };
          await _trackingNavMenu(payload);
          await store.dispatch('$_student/setStudentDetails', {
            studentId: student.studentId,
            autoCreateStudentData: webServiceSearchOnly,
            student,
            selectThisStudent: true,
          });
          store.commit('$_student/AddStudentSearched', student); 
          store.commit('$_student/setSelectedStudent', student);
          this.$emit('toggleStudentSearchBox');
        } else {
          alert.methods.ShowAlertModal(
            'Atención',
            this.resources['44'],
            'error',
            null
          );
        }
      }
    },
    setLoading(isLoading) {
      this.$emit('on-loading', isLoading);
    },
    goToPage(pageNumber) {
      this.paginationInfo.pageIndex = pageNumber;
      this.paginationInfo.currentPage = pageNumber;

      this.handleAdvancedSearch(this.currentSearch);
    },
    clean() {
      this.studentList = [];
      this.currentSearch = {};
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages(['44']);
    },
  },
  async mounted() {
    const { data: response } = await studentService.getImpediments();

    this.impedimentList = response.map((resp) => {
      resp.id = resp.name;
      return resp;
    });
  },
};
</script>
